import Alpine from 'alpinejs'

Alpine.data('localStorage', (options = {}) => {
  function readLocalStorage() {
    const data = {}
    for (var i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (!key.startsWith(prefix)) continue

      const value = localStorage.getItem(key)
      data[key.slice(prefix.length)] = serialize ? JSON.parse(value) : value
    }
    return data
  }

  const { prefix = '', serialize = true } = options
  const reactiveStorage = Alpine.reactive(readLocalStorage(prefix))

  window.addEventListener('storage', function onStorageChange(event) {
    if (event.storageArea !== localStorage) return
    if (!event.key || !event.key.startsWith(prefix)) return

    const key = event.key.slice(prefix.length)
    if (event.newValue === null) {
      delete reactiveStorage[key]
    } else {
      reactiveStorage[key] = serialize ? JSON.parse(event.newValue) : event.newValue
    }
  })

  const clone = value => JSON.parse(JSON.stringify(value))

  return {
    all() {
      return clone(reactiveStorage)
    },
    has(key) {
      return key in reactiveStorage
    },
    get(key) {
      if (!this.has(key)) return null

      return clone(reactiveStorage[key])
    },
    set(key, value) {
      const storedValue = serialize ? JSON.stringify(value) : value
      localStorage.setItem(prefix + key, storedValue)
      reactiveStorage[key] = value
    },
    upsert(key, value) {
      if (!this.has(key)) {
        this.set(key, value)
      }

      return this.get(key)
    },
    remove(key) {
      localStorage.removeItem(prefix + key)
      delete reactiveStorage[key]
    },
    clear() {
      Object.keys(reactiveStorage).forEach(key => {
        localStorage.removeItem(prefix + key)
        delete reactiveStorage[key]
      })
    },
    destroy() {
      window.removeEventListener('storage', onStorageChange)
    },
  }
})
